var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content", attrs: { type: "primary" } },
    [
      _c("cabin-list", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.view === "list",
            expression: "view==='list'"
          }
        ],
        ref: "cabinList",
        attrs: { context: _vm.context },
        on: {
          look: _vm.lookHandle,
          edit: _vm.editHandle,
          clone: _vm.cloneHandle,
          add: _vm.addHandle
        }
      }),
      _c("cabin-detail", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.view === "detail",
            expression: "view==='detail'"
          }
        ],
        ref: "cabinDetail",
        attrs: { context: _vm.context },
        on: {
          edit: _vm.editHandle,
          add: _vm.addHandle,
          clone: _vm.cloneHandle,
          back: _vm.backToList
        }
      }),
      _vm.copyWindow.visible
        ? _c("copy-window", {
            ref: "copyWindow",
            attrs: {
              visible: _vm.copyWindow.visible,
              source: _vm.copyWindow.source
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.copyWindow, "visible", $event)
              },
              copy: _vm.copyHandler
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }